import { isInView } from "./utils"

const scrollCart = {

cartLine: document.getElementById('addToCartLine'),
cartBtn: document.querySelector('.jsInView') as HTMLElement | undefined,
init() {
    window.addEventListener('scroll', () => {
        this.setScroll()
    })
}, 

setScroll() {
    if(isInView(this.cartBtn)) {
         
         this.cartLine?.classList.add('activeClass')
   
    } else {
        
    
        this.cartLine?.classList.remove('activeClass')
        
    }
}

}

export default scrollCart